/*eslint-disable*/ import React from "react";

// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// sections for this page

import Section3Team from "pages-sections/home-page/Section3Team.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";
import styles from "../pages-sections/services/ServicesSections.module.scss";




export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Our Team - Tribalism"
        image="/img/office-photos/mk-9.jpg"
        url="https://www.tribalism.com.au/team"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. We are experts in analytics and data using a human first approach to ensure quality work !"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      
      
      <div className={classes.main}> 
      
        <Section3Team />

      
      </div>

      <Footer
        
      />
    </div>
  );
}
